import { trigger, transition, style, animate } from '@angular/animations';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class AnimationDuration {
}
AnimationDuration.VERY_SLOW = 500;
AnimationDuration.SLOW = 400;
AnimationDuration.NOMRAL = 300;
AnimationDuration.FAST = 200;
AnimationDuration.VERY_FAST = 100;
if (false) {
    /** @type {?} */
    AnimationDuration.VERY_SLOW;
    /** @type {?} */
    AnimationDuration.SLOW;
    /** @type {?} */
    AnimationDuration.NOMRAL;
    /** @type {?} */
    AnimationDuration.FAST;
    /** @type {?} */
    AnimationDuration.VERY_FAST;
}
class AnimationEase {
}
AnimationEase.EASE_IN = 'cubic-bezier(0.55, 0, 0.55, 0.2)';
if (false) {
    /** @type {?} */
    AnimationEase.EASE_IN;
}
class AnimationDirection {
}
AnimationDirection.LEFT = 'Left';
AnimationDirection.RIGHT = 'Right';
AnimationDirection.UP = 'Up';
AnimationDirection.DOWN = 'Down';
if (false) {
    /** @type {?} */
    AnimationDirection.LEFT;
    /** @type {?} */
    AnimationDirection.RIGHT;
    /** @type {?} */
    AnimationDirection.UP;
    /** @type {?} */
    AnimationDirection.DOWN;
}
class AnimationUnit {
}
AnimationUnit.PX = 'px';
AnimationUnit.MS = 'ms';
if (false) {
    /** @type {?} */
    AnimationUnit.PX;
    /** @type {?} */
    AnimationUnit.MS;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const FadeDefault = {
    duration: AnimationDuration.NOMRAL,
    delay: 0,
    ease: AnimationEase.EASE_IN,
    translate: 30,
    direction: ''
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class Fade {
    /**
     * @param {?=} config
     * @return {?}
     */
    static fadeIn(config) {
        return [
            trigger('fadeIn' + (config.direction == null ? FadeDefault.direction : config.direction), [
                transition(':enter', [
                    style({
                        opacity: 0,
                        transform: 'translate3d(' +
                            ((config.direction === AnimationDirection.LEFT) || (config.direction === AnimationDirection.RIGHT) ?
                                (config.translate == null ?
                                    ((config.direction === AnimationDirection.LEFT) ?
                                        ('-' + FadeDefault.translate + AnimationUnit.PX) :
                                        (config.direction === AnimationDirection.RIGHT) ?
                                            (FadeDefault.translate + AnimationUnit.PX) : '0') :
                                    ((config.direction === AnimationDirection.LEFT) ?
                                        ('-' + config.translate + AnimationUnit.PX) :
                                        (config.direction === AnimationDirection.RIGHT) ?
                                            (config.translate + AnimationUnit.PX) : '0')) : '0') + ', ' +
                            ((config.direction === AnimationDirection.UP) || (config.direction === AnimationDirection.DOWN) ?
                                (config.translate == null ?
                                    ((config.direction === AnimationDirection.UP) ?
                                        ('-' + FadeDefault.translate + AnimationUnit.PX) :
                                        (config.direction === AnimationDirection.DOWN) ?
                                            (FadeDefault.translate + AnimationUnit.PX) : '0') :
                                    ((config.direction === AnimationDirection.UP) ?
                                        ('-' + config.translate + AnimationUnit.PX) :
                                        (config.direction === AnimationDirection.DOWN) ?
                                            (config.translate + AnimationUnit.PX) : '0')) : '0')
                            + ', 0)',
                    }),
                    animate((config.duration == null ? FadeDefault.duration : config.duration) +
                        AnimationUnit.MS + ' ' +
                        (config.delay == null ? FadeDefault.delay : config.delay) +
                        AnimationUnit.MS + ' ' +
                        (config.ease == null ? FadeDefault.ease : config.ease), style({
                        opacity: 1,
                        transform: 'translate3d(0, 0, 0)'
                    }))
                ])
            ])
        ];
    }
    /**
     * @param {?=} config
     * @return {?}
     */
    static fadeOut(config) {
        return [
            trigger('fadeOut' + (config.direction == null ? FadeDefault.direction : config.direction), [
                transition(':leave', [
                    style({
                        opacity: 1,
                        transform: 'translate3d(0, 0, 0)'
                    }),
                    animate((config.duration == null ? FadeDefault.duration : config.duration) +
                        AnimationUnit.MS + ' ' +
                        (config.delay == null ? FadeDefault.delay : config.delay) +
                        AnimationUnit.MS + ' ' +
                        (config.ease == null ? FadeDefault.ease : config.ease), style({
                        opacity: 0,
                        transform: 'translate3d(' +
                            ((config.direction === AnimationDirection.LEFT) || (config.direction === AnimationDirection.RIGHT) ?
                                (config.translate == null ?
                                    ((config.direction === AnimationDirection.LEFT) ?
                                        ('-' + FadeDefault.translate + AnimationUnit.PX) :
                                        (config.direction === AnimationDirection.RIGHT) ?
                                            (FadeDefault.translate + AnimationUnit.PX) : '0') :
                                    ((config.direction === AnimationDirection.LEFT) ?
                                        ('-' + config.translate + AnimationUnit.PX) :
                                        (config.direction === AnimationDirection.RIGHT) ?
                                            (config.translate + AnimationUnit.PX) : '0')) : '0') + ', ' +
                            ((config.direction === AnimationDirection.UP) || (config.direction === AnimationDirection.DOWN) ?
                                (config.translate == null ?
                                    ((config.direction === AnimationDirection.UP) ?
                                        ('-' + FadeDefault.translate + AnimationUnit.PX) :
                                        (config.direction === AnimationDirection.DOWN) ?
                                            (FadeDefault.translate + AnimationUnit.PX) : '0') :
                                    ((config.direction === AnimationDirection.UP) ?
                                        ('-' + config.translate + AnimationUnit.PX) :
                                        (config.direction === AnimationDirection.DOWN) ?
                                            (config.translate + AnimationUnit.PX) : '0')) : '0')
                            + ', 0)'
                    }))
                ])
            ])
        ];
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { Fade, FadeDefault as ɵa, AnimationDuration as ɵb, AnimationEase as ɵc, AnimationDirection as ɵd, AnimationUnit as ɵe };
//# sourceMappingURL=animations.js.map
